import { useId } from 'react';
import PropTypes from 'prop-types';
import {
  Column,
  DataRow,
  FormField,
  InputTextAreaField,
  Row,
  Typography,
} from '@tempmee/react';
import { MAX_DECISION_REASON_LENGTH } from './credentialV2Utils';

export const DECISION_REASON_LABEL = 'CS Reason Why Invalid or Verified:';

/**
 * CS's optional note on why an artifact credential was verified or invalidated
 * (GOTU-19450), saved with the status so Snowflake can compare it with the AI
 * parser's assessment. credential-service returns it to admins only.
 */
export const CsDecisionReasonField = ({ editMode, value, error, onChange }) => {
  const inputId = useId();
  const counterId = `${inputId}-counter`;
  const errorId = `${inputId}-error`;
  const reason = value || '';

  if (!editMode) {
    return (
      <DataRow
        label={DECISION_REASON_LABEL}
        value={<span className="break-words">{reason || '-'}</span>}
        orientation="stacked"
      />
    );
  }

  return (
    <FormField label={DECISION_REASON_LABEL} htmlFor={inputId} labelWeight="normal">
      <Column gap={1}>
        <InputTextAreaField
          id={inputId}
          value={reason}
          maxLength={MAX_DECISION_REASON_LENGTH}
          isError={!!error}
          aria-invalid={!!error}
          aria-describedby={error ? `${counterId} ${errorId}` : counterId}
          onChange={(e) => onChange(e.target.value)}
        />
        <Row justify="between" gap={2}>
          {/* data-field-error lets the form's save scroll to the first error. */}
          {error ? (
            <Typography
              id={errorId}
              variant="caption"
              className="text-error-500"
              data-field-error="true"
            >
              {error}
            </Typography>
          ) : (
            <span />
          )}
          <Typography id={counterId} variant="caption" className="text-secondary">
            {`${reason.length}/${MAX_DECISION_REASON_LENGTH}`}
          </Typography>
        </Row>
      </Column>
    </FormField>
  );
};

CsDecisionReasonField.propTypes = {
  editMode: PropTypes.bool.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  /** Receives the new reason text. */
  onChange: PropTypes.func.isRequired,
};

CsDecisionReasonField.defaultProps = {
  value: '',
  error: null,
};
